"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var chunk = function (collection, size) {
    if (size === void 0) { size = 10; }
    var result = [];
    // add each chunk to the result
    for (var x = 0; x < Math.ceil(collection.length / size); x++) {
        var start = x * size;
        var end = start + size;
        result.push(collection.slice(start, end));
    }
    return result;
};
exports.default = chunk;
